import {
  RadioButton as NRadioButton,
  type RadioButtonProps as NRadioButtonProps,
} from '@natera/material/lib/radioButton'
import { useId } from 'react'
import { cn } from '~/shared/lib/cn'
import { Text } from '~/shared/ui/text'
import './radio-button.scss'

interface RadioButtonProps extends Omit<NRadioButtonProps, 'id' | 'size'> {
  gutter?: boolean
  withinButton?: boolean
  fullLabelWidth?: boolean
  size?: 'small' | 'medium'
}

export function RadioButton({
  className,
  withinButton = false,
  label,
  gutter = false,
  fullLabelWidth = false,
  size = 'medium',
  ...rest
}: RadioButtonProps) {
  const id = useId()

  return (
    <NRadioButton
      id={id}
      className={cn(
        'c-radio-button',
        {
          'c-radio-button--no-gutter': !gutter,
          'c-radio-button--within-button': withinButton,
          'c-radio-button--full-label-width': fullLabelWidth,
          'c-radio-button--size-small': size === 'small',
          'c-radio-button--size-medium': size === 'medium',
        },
        className,
      )}
      label={
        !!label &&
        (withinButton ? (
          <span
            className={cn('text-xs leading-[22px] font-medium tracking-[1.4px] uppercase', {
              'ml-1.5': !gutter,
            })}
          >
            {label}
          </span>
        ) : (
          <Text
            className={cn('', {
              'ml-1.5': !gutter,
              'ml-1': size === 'small' && gutter,
            })}
            appearance="BODY2"
            truncated
            withTooltip
          >
            {label}
          </Text>
        ))
      }
      {...rest}
    />
  )
}
